import { makeStyles } from '@material-ui/core';

const useSnackBarStyles = makeStyles((theme) => {
    return ({
        success: {
            backgroundColor: '#388E3C',
            minWidth: theme.spacing(40)
        },
        info: {
            backgroundColor: '#323232',
            minWidth: theme.spacing(40),
            "& .MuiAlert-message": {
                width: "341px"
            }
        },
        error: {
            "& .MuiAlert-icon": {
                alignItems: "center"
            }
        }
    })
});

export default useSnackBarStyles;
